export const RECOVER_PASSWORD = 'https://www.tinco.app/recuperacao-de-senha';

export const HIRE = 'https://www.tinco.app/contrate';
